import type { ListingPage } from '../model';

export const initialState: StateInjection = {
  stateByPage: {},
};

export interface StateInjection {
  stateByPage: StateByPage;
}

export type StateByPage = PartialRecord<ListingPage, Injection>;

export type Injection = 'idle' | 'requested' | 'ready';

type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};
